import React from "react";
import DeckSliderCardsDesktop from "@qlik/qlik/src/components/CardDeckContainer/Home_Slider/DeckSliderCardsDesktop";
import DeckSliderCardsMobile from "@qlik/qlik/src/components/CardDeckContainer/Home_Slider/DeckSliderCardsMobile";
import useBreakpointUp from "@qlik/qlik/src/hooks/useBreakpointUp";
import breakpoints from "@qlik/qlik/src/lib/breakpoints";
import { getColorClassName } from "@qlik/qlik/src/lib/util/colors";
import { getSpacingClassName } from "@qlik/qlik/src/lib/util/spacing";

/**
 * DeckSliderCards component
 * @param {Object} data - The data object containing title and cardItems
 * @param {String} data.title - The title of the card deck
 * @param {Array} data.cardItems - The array of card items
 */
const DeckSliderCards = ({ data }) => {
    const { title, cardItems = [], backgroundColor, customId, additionalConfiguration } = data ?? {};
    // Get background color from the additionalConfiguration
    const { sectionColorMapping } = getColorClassName(backgroundColor);
    // Get the padding and margin values from the additionalConfiguration
    const sectionPaddingClassName = getSpacingClassName(additionalConfiguration, "pt-15 pb-14 md:py-20 lg:py-30");
    // Check if the device is a large device
    const largeDevice = useBreakpointUp(breakpoints.lg);
    return (
        <section
            className={`${sectionColorMapping?.bgColor ||
                "bg-stone bg-opacity-50"} ${sectionPaddingClassName} overflow-hidden`}
            id={customId}
        >
            <div className="container mb-15 lg:mb-20">
                {title && <h2 className="md:text-center whitespace-pre-wrap">{title}</h2>}
            </div>
            {/* Render DeckSliderCardsMobile for non-large devices */}
            {!largeDevice && <DeckSliderCardsMobile cards={cardItems} />}
            {/* Render DeckSliderCardsDesktop for large devices */}
            {largeDevice && <DeckSliderCardsDesktop cards={cardItems} />}
        </section>
    );
};

export default DeckSliderCards;
